module.exports = __webpack_public_path__ + "img/category-popular.123552ec.png";